module.exports = __webpack_public_path__ + "img/photo-0042.c525c76c.jpg";